import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail, MARK_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-ink grain overflow-hidden">
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-3">
            <img src={MARK_URL} alt="The Canary Report" className="h-10 w-10 rounded-full" />
            <span className="font-display font-extrabold text-xl">The Canary Report</span>
          </Link>
          <h1 className="font-display text-5xl xl:text-6xl font-black leading-[0.9] tracking-tight">Editor's<br />desk.</h1>
          <p className="text-white/50 max-w-sm">Manage stories, photo essays, and partnership inquiries.</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <p className="label text-ink/50 mb-3">Editor Login</p>
          <h2 className="font-display text-4xl font-bold mb-8">Sign in</h2>
          <div className="space-y-5">
            <div>
              <Label className="label" htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-2 rounded-none border-ink h-12" placeholder="editor@thecanary.report" />
            </div>
            <div>
              <Label className="label" htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-2 rounded-none border-ink h-12" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-ink text-white hover:bg-canary hover:text-ink h-13 py-6 label">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </div>
          <Link to="/" className="inline-block mt-6 label text-ink/50 hover:text-ink link-underline pb-1">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
